<template>
  <div class="row">
    <section>
      <h1>
        <translate translate-context="Content/Contact/Header"
          >Contact information</translate
        >
      </h1>
      <p>
        <translate translate-context="Content/Contact/Paragraph">
          If you need to personally contact the moderator of this project, you
          will find contact information below.
        </translate>
      </p>
      <p>
        <strong>
          <translate translate-context="Content/Contact/Paragraph">
            Please, use these channels responsibly and use the community
            channels whenever possible.
          </translate>
        </strong>
      </p>
      <h2>
        <i class="fa fa-shield"></i>&nbsp;
        <translate translate-context="Content/Contact/Header"
          >Report a Code of Conduct violation</translate
        >
      </h2>
      <p>
        <translate translate-context="Content/Contact/Paragraph">
          If you witnessed abuse, a violation of our Code of Conduct, or are
          yourself in a situation where you need the involvement of a moderator,
          contact:
        </translate>
      </p>
      <div class="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>
                <translate translate-context="Content/Contact/Table.Header"
                  >Moderator name</translate
                >
              </th>
              <th>
                <translate translate-context="Content/Contact/Table.Header"
                  >Email address</translate
                >
              </th>
              <th>
                <translate translate-context="Content/Contact/Table.Header"
                  >Languages</translate
                >
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Moderation Committee</td>
              <td>
                <a href="'mailto:moderators@funkwhale.audio"
                  >moderators@funkwhale.audio</a
                >
              </td>
              <td>English</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p>
        <translate translate-context="Content/Contact/Paragraph"
          >We will get back to you as soon as possible.</translate
        >
      </p>
      <h2>
        <i class="fa fa-send-o"></i>&nbsp;
        <translate translate-context="Content/Contact/Header"
          >Other requests and messages</translate
        >
      </h2>
      <p>
        <translate translate-context="Content/Contact/Paragraph">
          If you need to get in touch with core contributors about the project,
          potential partnerships, interviews or any other matter you don't want
          to share publicly on our community spaces, use the contact information
          below.
        </translate>
      </p>
      <div class="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>
                <translate translate-context="Content/Contact/Table.Header"
                  >Name</translate
                >
              </th>
              <th>
                <translate translate-context="Content/Contact/Table.Header"
                  >Roles</translate
                >
              </th>
              <th>
                <translate translate-context="Content/Contact/Table.Header"
                  >Email address</translate
                >
              </th>
              <th>
                <translate translate-context="Content/Contact/Table.Header"
                  >Languages</translate
                >
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Maintainers</td>
              <td>
                <translate translate-context="Content/Contact/Table.Header"
                  >Project maintainer</translate
                >
              </td>
              <td>
                <a href="'mailto:maintainers@funkwhale.audio"
                  >maintainers@funkwhale.audio</a
                >
              </td>
              <td>English</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
import PageMixin from "../PageMixin";

export default {
  mixins: [PageMixin],
  methods: {
    getInnerTitle() {
      return this.$pgettext("Content/Contact/Header", "Contact");
    }
  }
};
</script>
